module.exports = __webpack_public_path__ + "img/TrustBy_Healthrad.39e0b8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brochure/professional/TrustBy_Healthrad.jpg
// module id = 605
// module chunks = 5